import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const Container = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.secondary20};
    padding: ${theme.sz.s6} ${theme.sz.s0};
    display: grid;
    gap: ${theme.sz.s4};
    grid-template-areas:
      'image text'
      'button button';
    grid-template-columns: min-content auto;
    box-shadow: 0 0 0 100vmax ${theme.co.secondary20};
    clip-path: inset(0 -100vmax);

    @media (min-width: ${theme.sz.md}) {
      border-radius: ${theme.bo.medium};
      padding: ${theme.sz.s6} ${theme.sz.s8};
      grid-template-areas:
        'image text'
        '. button';
      box-shadow: unset;
      clip-path: unset;
    }
  `,
);

export const ImageWrapper = styled.div(
  () => css`
    grid-area: image;
  `,
);

export const Text = styled.div(
  ({ theme }) => css`
    grid-area: text;
    align-self: center;
    color: ${theme.co.neutral99};
    ${theme.typography.heading.mobile.xs};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xs};
    }
  `,
);

export const ButtonWrapper = styled.div(
  () => css`
    grid-area: button;
  `,
);

export const Image = styled.img(
  () => css`
    width: 100%;
  `,
);

export const ImmerseImageWrapper = styled.a(
  ({ theme }) => css`
    position: relative;
    display: flex;
    justify-content: center;
    width: ${theme.sz.s18};

    @media (min-width: ${theme.sz.md}) {
      width: ${theme.sz.s20};
    }
  `,
);

const PlayIconComponent = ({ ...props }) => <Icon {...props} name="play_filled" />;
export const PlayIcon = styled(PlayIconComponent)(
  ({ theme }) => css`
    position: absolute;
    color: ${theme.co.primary20};
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    margin-top: calc((${theme.sz.s18} - ${theme.sz.s8}) / 2);

    svg {
      width: 100%;
      height: 100%;
      padding-left: 20%;
    }

    @media (min-width: ${theme.sz.md}) {
      margin-top: calc((${theme.sz.s20} - ${theme.sz.s8}) / 2);
    }
  `,
);

export const MembotImageWrapper = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s18};

    @media (min-width: ${theme.sz.md}) {
      width: ${theme.sz.s16};
    }
  `,
);

export const InterestsImageWrapper = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s20};

    @media (min-width: ${theme.sz.md}) {
      width: ${theme.sz.s26};
    }
  `,
);
